import { Flex } from '@mantine/core';
import React from 'react';

type SelectableListProps<T> = {
  items: T[];
  getKey: (item: T) => string;
  renderRow: (item: T) => React.ReactNode;
};

export function SelectableList<T>({ items, getKey, renderRow }: SelectableListProps<T>) {
  return (
    <Flex direction="column" gap="xs">
      {items.map(item => (
        <React.Fragment key={getKey(item)}>{renderRow(item)}</React.Fragment>
      ))}
    </Flex>
  );
}
